import React, { useEffect, useState, useRef } from 'react';
import { ModalTabPanel } from '@strava/ui/ModalWithTabs';
import Button from '@strava/ui/Button';
import cx from '@strava/ui/clsx';
import useGoogle from 'hooks/useGoogle';
import { useInviteFriendsContext } from '../../../../state/InviteFriendsContext';

import styles from './InviteFriends.EmailTabPanel.scss';
import LinkGoogleAccount from './components/LinkGoogleAccount';

import { t } from '../../../../utils/InviteFriends.utils';
import GmailContactList from './components/GmailContactList/GmailContactList';

const EmailTabPanel = () => {
  const { state } = useInviteFriendsContext();

  const { error, requestContacts, contacts, isLinked, disconnect } = useGoogle({
    clientId: state.googleClientId,
    mocked: state.mocked
  });

  const [addresses, setAddresses] = useState('');

  const emailInputRef = useRef(null);

  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, [emailInputRef]);

  const handleFormSubmission = (event) => {
    event.preventDefault();
    // make xhr post to send email messages

    // eslint-disable-next-line no-console
    console.log(addresses);
  };

  const handleInputChange = (event) => {
    setAddresses(event.target.value);
  };

  return (
    <ModalTabPanel>
      {error && (
        <span className={styles.error}>{t('modal.error_message')}</span>
      )}
      <div className={styles.flexGrid}>
        <div className={cx(styles.col, styles.emailColumn)}>
          <h3 className={styles.headline}>{t('modal.email.subtitle')}</h3>
          <form onSubmit={handleFormSubmission}>
            <label htmlFor="emailInput">{t('modal.email.addresses')}</label>
            <textarea
              className={styles.emailInput}
              name="email"
              onChange={handleInputChange}
              ref={emailInputRef}
            />

            <label htmlFor="body">{t('modal.email.message_label')}</label>
            <textarea
              disabled={true}
              name="body"
              className={styles.emailBody}
              value={t('modal.email.message')}
            />

            <Button type="submit" variant="primary" id="signup-button">
              {t('modal.email.send')}
            </Button>
          </form>
        </div>
        <div className={styles.col}>
          {/** Link Google account or Display Contacts from Linked Google Account */}
          {isLinked ? (
            <GmailContactList contacts={contacts} disconnect={disconnect} />
          ) : (
            <LinkGoogleAccount
              requestContacts={requestContacts}
              error={error}
            />
          )}
        </div>
      </div>
    </ModalTabPanel>
  );
};

export default EmailTabPanel;
